"use client"

import * as React from "react"
import { ChevronsUpDown, GalleryVerticalEnd, Plus } from "lucide-react"
import RLogo from '@/public/images/R.svg'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@repo/web-ui/components/base/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@repo/web-ui/components/base/sidebar"
import ThemeToggle from "@repo/web-ui/components/ThemeToggle"
import { useRouter } from "next/navigation"


export function SidebarAppLogo() {
  const { isMobile } = useSidebar()
  const router = useRouter()

  return (
    <SidebarMenu >
      <SidebarMenuItem >
        <div className="flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left outline-hidden ring-sidebar-ring transition-[width,height,padding] focus-visible:ring-2 group-has-data-[sidebar=menu-action]/menu-item:pr-8 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 h-12 text-sm group-data-[collapsible=icon]:p-0! data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
              <div onClick={() => router.push('/')}
                className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg hover:cursor-pointer">
                <RLogo />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">RAVIK</span>
                <span className="truncate text-xs">Pitch Designer</span>
              </div>
              <ThemeToggle variant={'ghost'} size={'icon'} />
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
